// extracted by mini-css-extract-plugin
module.exports = {"tasks_list_container":"singleCollection_tasks_list_container__1-SL-","collection_title":"singleCollection_collection_title__qgRXL"};